export default __webpack_public_path__ + "assets/enterprise-two-two-small.c9b22f57340b4000ce049df4d2a5c1dd.png";